module.exports = __webpack_public_path__ + "static/media/bwsns1.957d5ed3.svg";